"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/***************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ***************************************************************************/
var EXPIRATION_DURATION = 2592000; // IN SECONDS (default 30 days)

var SHOULD_EXPIRE_DATA = true;
var DEFAULT_NAMESPACE = 'ccx-comments';
/**
 * Class to manage local storage data.
 */

var LocalStorageManager = /*#__PURE__*/function () {
  /**
   * Constructs a new LocalStorageManager object.
   */
  function LocalStorageManager() {
    _classCallCheck(this, LocalStorageManager);

    if (LocalStorageManager.instance) {
      return LocalStorageManager.instance;
    }

    this.shouldExpire = SHOULD_EXPIRE_DATA;
    this.expirationDuration = EXPIRATION_DURATION * 1000;
    this.data = _objectSpread({
      keys: [],
      items: {},
      createdTimeStamps: []
    }, this.shouldExpire && {
      expiringTimeStamps: []
    });
    this.LS = localStorage;
    this.namespace = DEFAULT_NAMESPACE;
    LocalStorageManager.instance = this;
    return this;
  }
  /**
   * Configures LocalStorageManager object.
   * @param {object} options - The LocalStorageManager configuration.
   * Configuration: namespace: value of main local storage key
   *                shouldExpire: boolean to decide if local storage should expire in future
   *                expirationDuration: if local storage can expire, duration in seconds from time it is created
   * @return {undefined}
   */


  _createClass(LocalStorageManager, [{
    key: "configure",
    value: function configure() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.shouldExpire = options.shouldExpire === undefined ? SHOULD_EXPIRE_DATA : options.shouldExpire;
      this.expirationDuration = (options.expirationDuration ? options.expirationDuration : EXPIRATION_DURATION) * 1000; // convert to milliseconds as unix timestamp(Date.Now()) is in milliseconds

      var dataFromStorage;

      if (options.namespace && options.namespace !== this.namespace) {
        // fetch/re-fetch from ls only when namespace(ls key) is changed
        this.namespace = options.namespace;
        dataFromStorage = JSON.parse(this.LS.getItem(this.namespace));
      }

      if (dataFromStorage && Object.prototype.hasOwnProperty.call(dataFromStorage, 'keys') && Object.prototype.hasOwnProperty.call(dataFromStorage, 'items')) {
        // if existing ls cache doesn't have expiringTimeStamps, cache data is stale, so remove it - use case where shouldExpire is changed to true from false. Also, vice versa.
        if (this.shouldExpire && !dataFromStorage.expiringTimeStamps || !this.shouldExpire && dataFromStorage.expiringTimeStamps) {
          this.empty();
        } else {
          this.data = dataFromStorage;
        }
      }
    }
    /**
     * Attempts to save the key/value pair to localStorage.
     * @return {boolean} - Whether or not the save was successful.
     */

  }, {
    key: "trySave",
    value: function trySave() {
      try {
        this.LS.setItem(this.namespace, JSON.stringify(this.data));
        return true;
      } catch (error) {
        // 18 for Safari: SecurityError: DOM Exception 18
        // 21 for some Safari
        // 22 for Chrome and Safari, 1014 for Firefox: QUOTA_EXCEEDED_ERR
        // -2147024882 for IE10 Out of Memory
        if (error.code === 18 || error.code === 21 || error.code === 22 || error.code === 1014 || error.number === -2147024882) {
          return false;
        }

        console.error("Error with localStorage:".concat(error));
        return true;
      }
    }
    /**
     * Attempts to remove the first item added to make room for the next.
     * @return {Object} The item being removed.
     */

  }, {
    key: "removeFirstIn",
    value: function removeFirstIn() {
      var firstIn = this.data.keys.pop();

      var removedItem = _objectSpread({
        key: firstIn,
        value: this.data.items[firstIn],
        createdTimeStamps: this.data.createdTimeStamps.pop()
      }, this.shouldExpire && {
        expiringTimeStamps: this.data.expiringTimeStamps.pop()
      });

      delete this.data.items[firstIn];
      return removedItem;
    }
    /**
     * Save the key/value pair to localStorage.
     * @return {Array} List of items being removed to make space in localstorage
     */

  }, {
    key: "save",
    value: function save() {
      var removed = [];

      while (!this.trySave()) {
        if (this.data.keys.length) {
          removed.push(this.removeFirstIn());
        } else {
          console.error("All items removed from ".concat(this.namespace, ", still can't save."));
        }
      }

      return removed;
    }
    /**
     * Set a key/value pair.
     * @param {string} key - The key to use in the key value pair.
     * @param {object} value - The value to use in the key value pair.
     * @return {object} The current instance of LocalStorageManager.
     */

  }, {
    key: "set",
    value: function set(key, value) {
      this.data.items[key] = value;
      var index = this.data.keys.indexOf(key);

      if (index > -1) {
        // if key already exists
        this.data.keys.splice(index, 1);

        if (this.shouldExpire) {
          this.data.expiringTimeStamps.splice(index, 1);
        }

        this.data.createdTimeStamps.splice(index, 1);
      }

      this.data.keys.unshift(key);

      if (this.shouldExpire) {
        this.data.expiringTimeStamps.unshift(Date.now() + this.expirationDuration);
      }

      this.data.createdTimeStamps.unshift(Date.now());
      this.save();
      return this;
    }
    /**
     * Get a value for a given key.
     * @param {string} [key] - The key to use in the key value pair.
     * @return {object} The item, or, all items when no key is provided.
     */

  }, {
    key: "get",
    value: function get(key) {
      if (key) {
        // get corresponding expiringTimeStamp for data expiration check
        var index = this.data.keys.indexOf(key);

        if (!this.shouldExpire) {
          return {
            data: this.data.items[key],
            createdTimeStamp: this.data.createdTimeStamps[index]
          };
        }

        if (!this.data.expiringTimeStamps) {
          //stale cache data without expirationTimeStamp. Let cache rehydrate
          return undefined;
        }

        if (index > -1) {
          var expiringTimeStamp = this.data.expiringTimeStamps[index];

          if (Date.now() < expiringTimeStamp) {
            return {
              data: this.data.items[key],
              createdTimeStamp: this.data.createdTimeStamps[index]
            };
          }

          this.remove(key);
          return undefined;
        }

        return undefined;
      } // Return all items with keys and created time stamps.


      return {
        keys: this.data.keys,
        data: this.data.items,
        createdTimeStamp: this.data.createdTimeStamps
      };
    }
    /**
     * All the keys currently being used.
     * @return {array} The keys.
     */

  }, {
    key: "keys",
    value: function keys() {
      return this.data.keys || [];
    }
    /**
     * Checks for the existence of a key.
     * @param {string} key - The key to check for.
     * @return {boolean} Wheter or not the key exist.
     */

  }, {
    key: "has",
    value: function has(key) {
      return this.data.keys.indexOf(key) !== -1;
    }
    /**
     * Removes a key/value pair from the collection.
     * @param {string} victim - The key/value pair to find, can be one of a String, Regular Expression or a Function.
     * @return {object} The current instance of LocalStorageManager.
     */

  }, {
    key: "remove",
    value: function remove(victim) {
      var _this = this;

      if (victim === null || !this.data.keys) {
        return this;
      }

      var keys = this.data.keys;
      keys.forEach(function (suspect, index) {
        if (suspect === victim) {
          _this.data.keys.splice(index, 1);

          _this.shouldExpire ? _this.data.expiringTimeStamps.splice(index, 1) : null;

          _this.data.createdTimeStamps.splice(index, 1);

          delete _this.data.items[suspect];
        }
      }, this);
      this.save();
      return this;
    }
    /**
     * Resets the local data and saves emptying out the localStorage to an empty state.
     * @return {object} The current instance of LocalStorageManager.
     */

  }, {
    key: "empty",
    value: function empty() {
      this.data = _objectSpread({
        keys: [],
        items: {},
        createdTimeStamps: []
      }, this.shouldExpire && {
        expiringTimeStamps: []
      });
      this.save();
      return this;
    }
  }]);

  return LocalStorageManager;
}();

var LocalStorageManagerInstance = new LocalStorageManager();
var _default = LocalStorageManagerInstance;
exports.default = _default;